import React, { useState, useEffect } from 'react'
import { Image, Spin, Alert } from 'antd'

interface ImagePreviewProps {
  imageUrl: string
  alt?: string
  width?: number
  height?: number
}

const ImagePreview: React.FC<ImagePreviewProps> = ({
  imageUrl,
  alt = 'Preview',
  width = 100,
  height = 100,
}) => {
  const [previewUrl, setPreviewUrl] = useState<string | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch(imageUrl, {
          method: 'GET',
          headers: {},
        })

        if (!response.ok) {
          throw new Error('Не удалось загрузить изображение')
        }

        const blob = await response.blob()
        const objectUrl = URL.createObjectURL(blob)

        setPreviewUrl(objectUrl)
      } catch (err) {
        setError('Ошибка загрузки изображения')
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    fetchImage()

    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl)
      }
    }
  }, [imageUrl])

  if (loading) {
    return <Spin size="small" />
  }

  if (error) {
    return <Alert message={error} type="error" showIcon />
  }

  return (
    <Image
      src={previewUrl}
      alt={alt}
      width={width}
      height={height}
      preview
      placeholder={<Spin size="small" />}
      onError={() => setError('Не удалось отобразить изображение')}
    />
  )
}

export default ImagePreview
